import React, { Component } from "react";
import PropTypes, { instanceOf } from "prop-types";
import { connect } from "react-redux";
import { withCookies, Cookies } from "react-cookie";
import classNames from "classnames";

import Icon from "../Icon";
import SubscribeButton from "../../../components/Library/SubscribeButton";
import { updateUnAuthedSubscriptions } from "../../../actions/user";

import styles from "./Subscribe.css";
import NewsletterSubscribeForm from "../NewsletterSubscribeForm/NewsletterSubscribeForm";
import FetchOnSubmit from "../FetchOnSubmit/FetchOnSubmit";
import validateEmail from "../../../utils/validateEmail";
import { getSecondsIn, setCookieParams } from "utils/cookies";
import { COOKIES } from "../../../config/constants";

class Subscribe extends Component {
  constructor(props) {
    super(props);

    this.state = {
      subscribing: false,
      alreadySubscribedTo: [],
      email: "",
    };
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubscribing = () => {
    this.setState({ subscribing: true });
  };

  onSubscribe = e => {
    e.preventDefault();

    const { cookies } = this.props;
    const { queryParams } = this.props;
    const userVars = {
      source: queryParams.utm_source || queryParams.source || "axios",
      medium: queryParams.utm_medium || queryParams.medium,
      campaign: queryParams.utm_campaign || queryParams.campaign,
      term: queryParams.utm_term || queryParams.term,
      content: queryParams.utm_content || queryParams.content,
      page: queryParams.utm_page || queryParams.page,
    };

    return this.props
      .updateUnAuthedSubscriptions(
        this.state.email,
        [this.props.subscription.id],
        null,
        userVars
      )
      .then(() => {
        cookies.set(
          COOKIES.AXIOS_SUBSCRIPTIONS,
          [
            ...(cookies.get(COOKIES.AXIOS_SUBSCRIPTIONS) || []),
            this.props.subscription.id,
          ],
          { ...setCookieParams(), maxAge: getSecondsIn({ days: 30 }) }
        );
      })
      .then(this.onSubscribeSuccess);
  };

  onSubscribeSuccess = () => {
    const { cookies } = this.props;
    cookies.set(
      COOKIES.AXIOS_SUBSCRIPTIONS,
      [
        ...(cookies.get(COOKIES.AXIOS_SUBSCRIPTIONS) || []),
        this.props.subscription.id,
      ],
      { ...setCookieParams(), maxAge: getSecondsIn({ days: 30 }) }
    );
    this.setState({
      subscribing: false,
      alreadySubscribedTo: [
        ...this.state.alreadySubscribedTo,
        this.props.subscription.id,
      ],
    });
  };

  render() {
    const { subscription, light } = this.props;
    if (!subscription) return null;
    const isSubscribed = this.state.alreadySubscribedTo.includes(
      subscription.id
    );

    const { queryParams } = this.props;
    const userVars = {
      source: queryParams.utm_source || queryParams.source || "axios",
      medium: queryParams.utm_medium || queryParams.medium,
      campaign: queryParams.utm_campaign || queryParams.campaign,
      term: queryParams.utm_term || queryParams.term,
      content: queryParams.utm_content || queryParams.content,
      page: queryParams.utm_page || queryParams.page,
    };

    return (
      <div className={this.props.className}>
        {this.state.subscribing ? (
          <div className={styles.subscribing}>
            <FetchOnSubmit
              method="POST"
              url="/readers/unauth-sub/"
              onSuccess={this.onSubscribeSuccess}
              validate={validateEmail}
            >
              {({ status, error, submit, reset }) => {
                return (
                  <NewsletterSubscribeForm
                    formClassName="gtm-newsletter-subscribe"
                    list={this.props.subscription.id}
                    submit={submit}
                    status={status}
                    error={error}
                    reset={reset}
                    placeholder={"Your Email Address"}
                    userVars={userVars}
                  />
                );
              }}
            </FetchOnSubmit>
          </div>
        ) : isSubscribed ? (
          <SubscribeButton
            className={classNames(
              styles.subscribed,
              light && styles.lightButton
            )}
            disabled
          >
            <Icon
              name="check/rounded"
              className={classNames(styles.check, light && styles.lightCheck)}
            />
            Subscribed
          </SubscribeButton>
        ) : (
          <SubscribeButton
            className={classNames(
              styles.subscribe,
              light && styles.lightButton
            )}
            onClickSubscribe={
              this.props.isLoggedIn ? this.onSubscribe : this.onSubscribing
            }
            disabled={this.state.subscribing && this.state.email === ""}
          >
            Subscribe
          </SubscribeButton>
        )}
      </div>
    );
  }
}

Subscribe.propTypes = {
  subscription: PropTypes.object,
  light: PropTypes.bool,
  queryParams: PropTypes.object,
  cookies: instanceOf(Cookies).isRequired,
};

Subscribe.defaultProps = {
  queryParams: {},
};

const SubscribeWithRedux = connect(
  null,
  { updateUnAuthedSubscriptions }
)(Subscribe);

export default withCookies(SubscribeWithRedux);
